import type { ReactNode } from 'react';
import styles from './Badge.module.css';

export type BadgeProps = {
  tone?: 'default' | 'accent' | 'danger';
  children: ReactNode;
};

export function Badge({ tone = 'default', children }: BadgeProps) {
  return <span className={`${styles['badge']} ${styles[tone]}`}>{children}</span>;
}
